import React from 'react';
import ItemManager from '../components/ItemManager';

const HomePage = () => {

  return (
    <div>
      <ItemManager />
    </div>
  );
};

export default HomePage;
